import React, { useEffect, useState } from "react";
import { LabelHLPure, InputHLPure, ButtonHLPure } from "../../pures";
import { Container, Grid } from '@material-ui/core'
import { Avatar } from "@progress/kendo-react-layout";
import "./profile-administration-principal-view.css"

const ProfileAdministrationAddressView = (props) => {
    let {
        t,
        userPathImage,
        handleImage,
        handleShowPrincipalView,
        address,
        validator,
        updateAddress
    } = props

    const [userAddressId, setAddressId] = useState(0)
    const [userStreet, setStreet] = useState('')
    const [userColony, setColony] = useState('')
    const [userTown, setTown] = useState('')
    const [userState, setUserState] = useState('')
    const [userCP, setCp] = useState('')
    const [errorInputStreet, setErrorInputStreet] = useState(false)
    const [errorInputStreetText, setErrorInputStreetText] = useState('')
    const [errorColony, setErrorColony] = useState(false)
    const [errorColonyText, setErrorColonyText] = useState('')
    const [errorTownship, setErrorTownship] = useState(false)
    const [errorTownshipText, setErrorTownshipText] = useState('')
    const [errorState, setErrorState] = useState(false)
    const [errorStateText, setErrorStateText] = useState('')
    const [errorCP, setErrorCp] = useState(false)
    const [errorCpText, setErrorCpText] = useState('')

    useEffect(() => {
        if (!address) return
        let street = (address.street) ? address.street : ''
        let colony = (address.colony) ? address.colony : ''
        let township = (address.township) ? address.township : ''
        let state = (address.state) ? address.state : ''
        let zipCode = (address.zipCode) ? address.zipCode : ''
        let addressId = (address.id) ? address.id : ''

        setStreet(street)
        setColony(colony)
        setTown(township)
        setUserState(state)
        setCp(zipCode)
        setAddressId(addressId)

    }, [address])

    const onChangeInputs = (e, setValue, setError, setErrorText) => {
        let value = e.target.value
        setValue(value)

        if (setError, setErrorText) {
            setError(false)
            setErrorText('')
        }
    }

    const saveData = () => {
        let street = (userStreet) ? userStreet.trim() : ''
        let colony = (userColony) ? userColony.trim() : ''
        let township = (userTown) ? userTown.trim() : ''
        let state = (userState) ? userState.trim() : ''
        let cp = (userCP) ? userCP.trim() : ''

        let streetValidated = ''
        let colonyValidated = ''
        let townshipValidated = ''
        let stateValidated = ''
        let cpValidated = ''

        if (street) {
            streetValidated = validator.streetValidator(street);
        }

        if (colony) {
            colonyValidated = validator.colonyValidator(colony);
        }

        if (township) {
            townshipValidated = validator.townValidator(township);
        }

        if (state) {
            stateValidated = validator.stateValidator(state);
        }

        if (cp) {
            cpValidated = validator.zipCodeValidator(cp);
        }

        if (streetValidated !== '') {
            setErrorInputStreet(true)
            setErrorInputStreetText(t("profile.validator.streetValidator"))
            return
        }

        if (colonyValidated !== '') {
            setErrorColony(true)
            setErrorColonyText(t("profile.validator.colonyValidator"))
            return
        }

        if (townshipValidated !== '') {
            setErrorTownship(true)
            setErrorInputStreetText(t("profile.validator.townValidator"))
            return
        }

        if (stateValidated !== '') {
            setErrorState(true)
            setErrorStateText(t("profile.validator.stateValidator"))
            return
        }

        if (cpValidated !== '') {
            setErrorCp(true)
            setErrorCpText(t("profile.validator.zipCodeValidator"))
            return
        }

        let data = {
            addressId: userAddressId,
            street,
            internalNumber: '',
            externalNumber: '',
            colony,
            township,
            state,
            country: '',
            zipCode: cp
        }

        updateAddress(data, handleShowPrincipalView)
    }


    return (
        <Container>
            <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="profileAdministrationPrincipalView-container"
            >
                <div className="profileAdministrationPrincipalView-body">
                    <LabelHLPure
                        text={t("requestSignatureDetailView.updateData")}
                        fontSize={'14px'}
                    />
                    <div className="profileAdministrationPrincipalView-grid-data">
                        <div className="profileAdministrationPrincipalView-container-image">
                            <Avatar
                                shape="circle"
                                type="image"
                                className="profile-container-img"
                            >
                                <img
                                    src={userPathImage}
                                    alt="user image"
                                    className="k-avatar-image profile-img imageSizesStyles"
                                />
                            </Avatar>
                            <div className="profileAdministrationPrincipalView-container-btn">
                                <div className="custom-input-file-p profileAdministrationPrincipalView-btn-image"
                                    xs={8}
                                    lg={8}
                                    md={8}
                                    sm={8}
                                    es={8}
                                >
                                    <input
                                        className="input-file-p"
                                        type="file"
                                        accept="image/*"
                                        id="file"
                                        onClick={(e) => (e.target.value = null)}
                                        onChange={(e) => handleImage(e)}
                                    />
                                    {t("dialogUpdateUserAddress.tooltipButtonImageEdit")}
                                </div>
                            </div>
                        </div>
                        <div className="profileAdministrationPrincipalView-container-data">
                            <InputHLPure
                                labelInput={props.t("register.address.street")}
                                valueInput={userStreet}
                                typeInput={"text"}
                                handleChangeInput={(e) => onChangeInputs(e, setStreet, setErrorInputStreet, setErrorInputStreetText)}
                                inputActive={true}
                                errorInput={errorInputStreet}
                                errorInputText={errorInputStreetText}
                            />
                            <InputHLPure
                                labelInput={props.t("register.address.suburb")}
                                valueInput={userColony}
                                handleChangeInput={(e) => onChangeInputs(e, setColony, setErrorColony, setErrorColonyText)}
                                typeInput={"text"}
                                inputActive={true}
                                errorInput={errorColony}
                                errorInputText={errorColonyText}
                            />
                            <InputHLPure
                                labelInput={props.t("register.address.town")}
                                valueInput={userTown}
                                handleChangeInput={(e) => onChangeInputs(e, setTown, setErrorTownship, setErrorTownshipText)}
                                typeInput={"text"}
                                inputActive={true}
                                errorInput={errorTownship}
                                errorInputText={errorTownshipText}
                            />
                            <InputHLPure
                                labelInput={props.t("register.address.state")}
                                valueInput={userState}
                                typeInput={"text"}
                                handleChangeInput={(e) => onChangeInputs(e, setUserState, setErrorState, setErrorStateText)}
                                inputActive={true}
                                errorInput={errorState}
                                errorInputText={errorStateText}
                            />
                            <InputHLPure
                                labelInput={props.t("register.address.zipCode")}
                                valueInput={userCP}
                                typeInput={"text"}
                                handleChangeInput={(e) => onChangeInputs(e, setCp, setErrorCp, setErrorCpText)}
                                inputActive={true}
                                errorInput={errorCP}
                                errorInputText={errorCpText}
                            />
                        </div>
                    </div>
                    <div className="profileAdministrationPrincipalView-container-btns">
                        <div className="profileAdministrationPrincipalView-arrow-btns">
                            <ButtonHLPure
                                nameBtn={t("button.cancel")}
                                primary={false}
                                onClickBtn={() => handleShowPrincipalView()}
                            />
                        </div>
                        <ButtonHLPure
                            nameBtn={t("profileAdministrationPrincipalView.btn.update")}
                            primary={true}
                            onClickBtn={() => saveData()}
                        />
                    </div>
                </div>
            </Grid>
        </Container>
    )
}

export { ProfileAdministrationAddressView as default }